<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30">
    <path fill="#275AE6" stroke="#fff" stroke-width="2" d="M29 15c0 7.732-6.268 14-14 14S1 22.732 1 15 7.268 1 15 1s14 6.268 14 14z"/>
    <rect width="2" height="2" x="14" y="9" fill="#fff" stroke="#fff" stroke-width=".5" rx="1"/>
    <rect width="2" height="8" x="14" y="13" fill="#fff" stroke="#fff" stroke-width=".5" rx="1"/>
</svg>
